import { Box, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { setRemoveRoomUnread } from 'src/redux/slices/staff';
import { useDispatch, useSelector } from 'src/redux/store';
import BottomBar from 'src/components/_chats/staff/components/BottomBar';
import useAuth from 'src/hooks/useAuth';
import ChatInternoMessagesList from './ChatInternoMessagesList';
import ChatInternoHeaderDetail from './ChatInternoHeaderDetail';
import ChatInternoBottombar from './ChatInternoBottombar';
import SkeletonChatWindow from 'src/components/skeleton/chats/SkeletonChatWindow';
import ChatInternoSkeletonHeader from './components/ChatInternoSkeletonHeader';


export default function ChatInternoWindow() {
  const dispatch = useDispatch();
  const { conversationKey } = useParams();
  const { staff, loadingMsg } = useSelector((state) => state.staff);
  const [selectedMessage, setSelectedMessage] = useState(null);

  const {user} = useAuth()


 useEffect(() => {
    if (conversationKey) {
      dispatch(setRemoveRoomUnread(conversationKey));
    }
  }, [dispatch, conversationKey]);



  return (
    <div className="flex flex-col w-full border rounded-lg  bg-[url('https://i.pinimg.com/originals/58/c3/33/58c33377dfcbb3022493dec49d098b02.jpg') ]  bg-cover bg-cente">

      {loadingMsg ? (
          <div class name="flex flex-col h-screen x-auto p-4 ">
            <ChatInternoSkeletonHeader />
            <SkeletonChatWindow />
          </div>
        ) :  (
            <>
            <ChatInternoHeaderDetail chat={staff} />
            <ChatInternoMessagesList
                    onReply={value => {
                      console.log('injetando em chatInternoWindow', value)
                      setSelectedMessage(value);
                    }}
            />
            <ChatInternoBottombar 
            user={user} 
            chat={staff}
            selectedMessage={selectedMessage}
            closeReplyMsg={() => {
              setSelectedMessage(null); 
            }}
             />
            </>
        ) }
     
     
    </div>
  );
}
